export var APP_NAME = 'ori-security-identity-ui';
export var PACKAGE_NAME = '@ori/login-page';
export var EMOTION_CACHE_KEY = "".concat(APP_NAME, "-emotion-cache-key");
export var APP_ROOT_ELEMENT_ID = "".concat(APP_NAME, "-root");
export var TIMEOUT_DURATION = 60000;
export var NOT_LOGGED_IN_USER_ID = -1;
/**
 * SWR config
 */ export var swrConfig = {
    errorRetryCount: 3,
    errorRetryInterval: 10000,
    focusThrottleInterval: 300000,
    shouldRetryOnError: true,
    suspense: false,
    /* eslint-disable max-params -- library requires too many parameters */ onErrorRetry: function(error, key, config, revalidate, param) {
        var retryCount = param.retryCount;
        var _error_data;
        var _error_data_status;
        var statusCode = Number((_error_data_status = error === null || error === void 0 ? void 0 : (_error_data = error.data) === null || _error_data === void 0 ? void 0 : _error_data.status) !== null && _error_data_status !== void 0 ? _error_data_status : 200);
        if (statusCode >= 400 && statusCode < 500) {
            return;
        }
        var rCount = retryCount !== null && retryCount !== void 0 ? retryCount : 1;
        var _config_errorRetryCount;
        if (rCount >= ((_config_errorRetryCount = config.errorRetryCount) !== null && _config_errorRetryCount !== void 0 ? _config_errorRetryCount : 0)) {
            return;
        }
        setTimeout(function() {
            return void revalidate({
                retryCount: rCount
            });
        }, config.errorRetryInterval);
    }
};
